import {connect} from 'react-redux';
import {get} from 'lodash';
import {createStructuredSelector} from 'reselect';

import {COACHES_ONLY, FRONTLINE_COACHES} from '/enum/filter.enum';
import {withNavigation} from '/provider/NavigationProvider';
import {withSafeArea} from '/provider/SafeAreaProvider';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {
  getSearchResults,
  UPDATE_SEARCH_INPUT,
} from '/redux/action/search.action';
import {
  hasSearchResultsBySearchInput,
  searchInput,
} from '/redux/selector/search.selector';
import {withHOC} from '/util/hoc.util';

import {SearchHeader} from './SearchHeader';

export const SearchHeaderConnected = withHOC(
  connect(
    createStructuredSelector({
      hasSearchResults: hasSearchResultsBySearchInput,
      searchInput,
    }),
    dispatch => ({
      fetchSearchResults: ({
        searchInput,
        searchOnlyInFrontlines,
        searchOnlyInCoaches,
        filterParam,
      }: any) =>
        dispatch(
          // @ts-expect-error TS(2345): Argument of type '{ (dispatch: any, getState: any)... Remove this comment to see the full error message
          getSearchResults({
            searchInput,
            searchOnlyInFrontlines,
            searchOnlyInCoaches,
            filterParam,
          }),
        ),
      updateSearchInput: ({searchInput}: any) =>
        dispatch({
          type: UPDATE_SEARCH_INPUT,
          payload: {searchInput},
        }),
    }),
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      fetchSearchResults: ({searchInput, recordsParams}: any) => {
        const filterParam = get(recordsParams, ['filterBy']);

        const searchOnlyInFrontlines = filterParam === FRONTLINE_COACHES;
        const searchOnlyInCoaches = filterParam === COACHES_ONLY;

        return dispatchProps.fetchSearchResults({
          searchInput,
          filterParam,
          searchOnlyInFrontlines,
          searchOnlyInCoaches,
        });
      },
    }),
  ),
  withNavigation,
  withSafeArea,
  withTheme,
  withCompetency,
)(SearchHeader);
